import { render } from "./migration.harvesterhci.io.vmwaresource.vue?vue&type=template&id=889e8f24"
import script from "./migration.harvesterhci.io.vmwaresource.vue?vue&type=script&lang=js"
export * from "./migration.harvesterhci.io.vmwaresource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__